import moment from "moment";

export enum HANDOVER_NOTES_TYPE {
    Active = 'Active',
    Completed = 'Completed',
}

export enum ORDER_BY_TYPE {
    Created_Date = 'Created Date',
    Modified_Date = 'Modified Date'
}

export const HANDOVER_NOTES_DEFAULT_ACTIVE_PAGGING_PAYLOAD = {
  page_number: 1,
  page_size: 10,
  client_id: 0,
  sort: [
    {
      field: 'hand_over_note_modified_at',
      dir: 'desc',
    },
  ],
  filter: [],
  global_filter_value: '',
  global_fields: [
    {
      field: 'hand_over_note_text',
      type: 'string',
    },
  ],
  is_all: true,
  status: true,
  type: 'Active',
  location_id: 0,
  min_date: moment().startOf('isoWeek').format('YYYY-MM-DDT00:00:00'),
  max_date: moment().endOf('isoWeek').format('YYYY-MM-DDT23:59:59'),
};

export const HANDOVER_NOTES_DEFAULT_COMPLETE_PAGGING_PAYLOAD = {
  page_number: 1,
  page_size: 10,
  client_id: 0,
  sort: [
    {
      field: 'hand_over_note_modified_at',
      dir: 'desc',
    },
  ],
  filter: [],
  global_filter_value: '',
  global_fields: [
    {
      field: 'hand_over_note_text',
      type: 'string',
    },
  ],
  is_all: true,
  status: true,
  type: 'Completed',
  location_id: 0,
  min_date: moment().startOf('isoWeek').format('YYYY-MM-DDT00:00:00'),
  max_date: moment().endOf('isoWeek').format('YYYY-MM-DDT23:59:59'),
};
